module.exports = __webpack_public_path__ + "img/melanie-dubin-beier.1d13b206.jpg";